import { Availability as GrpcAvailability, AvailabilitySlot as GrpcAvailabilitySlot, NearestAvailability as GrpcNearestAvailability } from '@optimusride/client-library/grpc/reservation_pb';
import { Reservation, toReservation } from './reservation';
import { toLocalDate } from '@optimusride/client-library/utils';
import { Moment } from 'moment-timezone';
export interface Availability {
  date: Moment;
  slots: AvailabilitySlot[];
}

export interface AvailabilitySlot {
  timestamp: Moment;
  seatsRemaining: number;
  leadTime: string;
  reservations: Reservation[];
}

export interface NearestAvailability {
  before: string[];
  at: string[];
  after: string[];
  timezone: string;
}

export const EmptyNearestAvailability: NearestAvailability = {
  before: [],
  at: [],
  after: [],
  timezone: ''
}

function toAvailabilitySlot(slot: GrpcAvailabilitySlot, operatingAreaTimezone: string): AvailabilitySlot {
  return {
    timestamp: toLocalDate(slot.getTimestamp(), operatingAreaTimezone),
    seatsRemaining: slot.getSeatsRemaining(),
    leadTime: slot.getLeadTime(),
    reservations: slot.getReservationsList().map(r => toReservation(r, operatingAreaTimezone))
  };
}

export function toAvailability(availability: GrpcAvailability, operatingAreaTimezone: string): Availability {
  return {
    date: toLocalDate(availability.getDate(), operatingAreaTimezone),
    slots: availability.getSlotsList().map(s => toAvailabilitySlot(s, operatingAreaTimezone))
  };
}

export function toNearestAvailability(availability: GrpcNearestAvailability): NearestAvailability {
  return {
    before: availability.getBeforeList(),
    at: availability.getAtList(),
    after: availability.getAfterList(),
    timezone: availability.getTimeZone()
  };
}
